export class DeleteClusterINModel { 
    idCluster: number
}